<template>
    <div>
        <key-data :users="users" :desks="desks" :bookings="bookings" :permanentBookings="permanentBookings"></key-data>
        <full-card>
            <template v-slot:header>
                <div v-if="!showInput">Auslastung {{ labels[0] }} - {{ labels.slice(-1)[0] }}</div>

            </template>
            <div v-if="!loading">
                <chart-bar-line-stacked v-show="dataType ==='data'" :bookings="bookings" :desks="desks" :users="users"
                                        :permanentBookings="permanentBookings"
                                        :labels="labels"
                                        :show-export="showInput"
                ></chart-bar-line-stacked>

   <!--             <chart-bar-line-stacked v-show="dataType ==='logData'" :bookings="logBookings" :desks="logDesks"
                                        :permanentBookings="logpermanentBookings"
                                        :labels="logLabels"
                                        :show-export="showInput"
                ></chart-bar-line-stacked> -->
            </div>
        </full-card>
    </div>
</template>

<script>
import FullCard from "../components/UI/FullCard";
import ChartBarLineStacked from "../components/Chart/ChartBarLineStacked";
import moment from "moment";
import ButtonSecondary from "../components/UI/ButtonSecondary"
import SelectMenu from "../components/UI/SelectMenu.vue"
import KeyData from "../components/KeyData.vue"

export default {
    name: "HourlyAttendanceStatistic",

    components: {
        FullCard,
        ButtonSecondary,
        ChartBarLineStacked,
        SelectMenu,
        KeyData,
    },

    props: {
        zoneId: {},
        floorId: {},
        showInput: {
            default: true,
        },
        isPrev: {
            default: false,
        },
      from: {
        type: String,
      },
      to: {
        type: String,
      },
      days: {
        default: "activeWorkingDays",
      },
      filter: {
        type: String,
        default: "weeks"
      },
      dataType: {
          type: String,
        default:"data"
      }

    },

    data: () => ({
        bookings: [],
        desks: [],
        permanentBookings: [],
        logBookings: [],
        logDesks: [],
        logpermanentBookings: [],
        logLabels: [],
        labels: [],
        history: [],
        loading: false,
        users: [],

    }),

    mounted() {
            this.load();
    },

    watch: {
        filter() {
            this.load();
        },
        zoneId() {
          this.load();
        },
        floorId() {
          this.load();
        },
        to() {
          this.load();
        },
        loading(curr,prev){
            this.$emit('setLoading', curr);
        },
        days(){
          this.load();
        }
    },

    computed: {},

    methods: {
        download() {
            window.open('/admin/statistics/export');
        },
        load() {
            this.loading = true;
            let params = {
                periodicity: this.filter,
                zone: this.zoneId,
                floor: this.floorId,
                days: this.days,
          }
          if(this.from && this.to){
            params.from = this.from;
            params.to = this.to;
          }else{
            params.filter = this.filter
            params.date = new Date();
          }

          if (!this.to || !this.from) {
              return;
          }

          this.$http.get('/admin/weekly_stats', {
               params
            }).then(result => {
                this.loading = false;
                this.labels = result.data.oldData.map(g => g.day);
                this.permanentBookings = result.data.oldData.map(g => g.permanentBookings);
                this.bookings = result.data.oldData.map(g => g.bookings);
                this.desks = result.data.oldData.map(g => g.desks);
                this.logpermanentBookings = result.data.history.map(g => g.owner_booking_count);
                this.logBookings = result.data.history.map(g => g.bookings_count);
                this.logDesks = result.data.history.map(g => g.desks_count);
                this.logLabels = result.data.history.map(g => g.day);
                this.users = result.data.oldData.map(g => g.users);

            }).catch(error => {
                this.$root.$emit('error', error);
            })

        },
    }

}
</script>

<style>

</style>
